// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3YwfO","footer":"ModalUpdate_footer__2JbST"};